import { render, staticRenderFns } from "./wrapper-list.vue?vue&type=template&id=0acf1c18&scoped=true&"
import script from "./wrapper-list.vue?vue&type=script&lang=js&"
export * from "./wrapper-list.vue?vue&type=script&lang=js&"
import style0 from "./wrapper-list.vue?vue&type=style&index=0&id=0acf1c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf1c18",
  null
  
)

export default component.exports